import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  markers: null,
  markerInfo: {},
};

export const mapSlice = createSlice({
  name: "map",
  initialState,
  reducers: {
    SET_MAP_MARKERS_DATA: (state, { payload }) => {
      state.markers = payload;
    },

    SET_MAP_MARKER_INFO: (state, { payload }) => {
      state.markerInfo = payload;
    },
  },
});

export const { SET_MAP_MARKERS_DATA, SET_MAP_MARKER_INFO } = mapSlice.actions;

export default mapSlice.reducer;
